/**
 * /* eslint-disable no-unused-vars
 *
 * @format
 */

/** @format */

import { TextField } from "@mui/material";
import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import { Row } from "react-bootstrap";
import Col from "react-bootstrap/cjs/Col";

import { Formik, Form, Field } from "formik";
import qs from "qs";

// import { FaAngleDown } from "react-icons/fa";
import DialogContentText from "@mui/material/DialogContentText";
// import { components } from "react-select";
import CustomSelectAsync from "src/components/CustomSelectAsync";
// import Waba from "../../dao/Waba";
import Cost from "../../dao/Cost";
import swal from "../../reusables/CustomSwal";
import useGetPhoneNumberByWABA from "../../hooks/useGetPhoneNumberByWABA";
import { useLocation } from "react-router";
import { useNavigate } from "react-router-dom";

// const TABLE_HEAD = [
//   { id: "count", label: "No.", alignRight: false, sortable: false },
//   { id: "waba_id", label: "WABA ID", alignRight: false, sortable: true },
//   // {id: 'role', label: 'Role', alignRight: false, sortable: true},
// ];

// const DropdownIndicator = (props) => {
//   return (
//     components.DropdownIndicator && (
//       <components.DropdownIndicator {...props}>
//         <FaAngleDown color={"grey"} />
//       </components.DropdownIndicator>
//     )
//   );
// };

export default function UpdateOTPManagementDialog(props) {
  const navigate = useNavigate();
  // const { data: dataWaba, isLoading: isLoadingWaba } = useGetWABA();

  // console.log(dataWaba, isLoadingWaba);
  const location = useLocation();
  const { open, onClose, details } = props;
  // console.log(details);
  const queryParams = qs.parse(location.search, { ignoreQueryPrefix: true });

  let idParam = queryParams.waba_id;
  const { data: dataPhoneNumber, isLoading: isLoadingPhoneNumber } =
    useGetPhoneNumberByWABA(idParam);

  const [initData, setInitData] = useState({
    waba_id: "",
    phone_number: "",
    tenant_id: "",
    cost_business_utility: 0,
    cost_user: 0,
    cost_business_authentication: 0,
    cost_business_marketing: 0,
  });
  // console.log("initData", initData);

  React.useEffect(() => {
    setInitData({
      ...initData,
      waba_id: details.waba_id,
      phone_number: details.phone_number,
      tenant_id: details.tenant_id,
      cost_business_utility: details.cost_business_utility,
      cost_user: details.cost_user,
      cost_business_authentication: details.cost_business_authentication,
      cost_business_marketing: details.cost_business_marketing,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [details]);

  // const [wabaId, setWabaId] = useState(null);
  // const [wabaName, setWabaName] = useState(null);
  // const [wabaDesc, setWabaDesc] = useState(null);
  // const [wabaIndustry, setWabaIndustry] = useState("none");
  // const [wabaWebsite, setWabaWebsite] = useState(null);

  // const reset = () => {
  //   setWabaId(null);
  // };

  const onSubmit = async (values) => {
    try {
      swal
        .fire({
          title: "",
          text: "Are you sure you want to edit this item?",
          icon: "warning",
          showCancelButton: true,
          confirmButton: "Yes",
          confirmButtonColor: "#3085d6",
          cancelButton: "Cancel",
          // cancelButtonColor: '#d33',
        })
        .then(async (result) => {
          try {
            if (result.isConfirmed) {
              let res = await Cost.updateCost(values, details.phone_number);
              if (res.id || res.success) {
                await swal.fire({
                  title: "",
                  text: "Creation Successful",
                  icon: "success",
                });
              }
              handleClose(true);
            } else {
              await swal.fire({
                title: "",
                text: "Creation Failed",
                icon: "error",
              });
            }
          } catch (e) {
            console.error(e);
            await swal.fire({
              title: "",
              text: "Phone Number has been used",
              icon: "error",
            });
          }
          await navigate(0);
        });
    } catch (e) {
      console.log(e);
    }
  };

  const reset = () => {
    // setWabaId(null);
  };

  const handleClose = (refresh) => {
    reset();
    onClose(refresh);
  };

  return (
    <>
      <Dialog
        fullWidth={true}
        maxWidth={"sm"}
        open={open}
        onClose={() => onClose()}
      >
        <Formik
          enableReinitialize
          // validationSchema={FormSubmission1Schema}
          initialValues={initData}
          onSubmit={(values) => {
            onSubmit(values);
          }}
        >
          {(props) => {
            const { values, handleChange } = props;

            return (
              <Form>
                <DialogTitle>Add WABA</DialogTitle>
                <DialogContent>
                  <DialogContentText>WABA ID</DialogContentText>
                  <Row>
                    <Col md={12}>
                      <TextField
                        name="waba_id"
                        sx={{
                          "& legend": { display: "none" },
                          "& fieldset": { top: 0 },
                        }}
                        value={values.waba_id}
                        onChange={handleChange}
                        fullWidth
                        placeholder={"WABA ID"}
                        InputLabelProps={{ shrink: true }}
                      />
                    </Col>
                  </Row>

                  <Row>
                    <Col md={12}>
                      <DialogContentText>Phone Number</DialogContentText>
                      <Field
                        className="custom-select"
                        name="phone_number"
                        data={dataPhoneNumber}
                        isLoading={isLoadingPhoneNumber}
                        component={CustomSelectAsync}
                        placeholder="Pilih Phone Number"
                        isMulti={false}
                      />
                    </Col>
                  </Row>

                  <Row>
                    <DialogContentText>Tenant ID</DialogContentText>
                    <TextField
                      name="tenant_id"
                      sx={{
                        "& legend": { display: "none" },
                        "& fieldset": { top: 0 },
                      }}
                      onChange={handleChange}
                      value={values.tenant_id}
                      fullWidth
                      placeholder={"Tenant ID"}
                      inputLabelProps={{ shrink: true }}
                    />
                  </Row>

                  <Row>
                    <DialogContentText>Cost User</DialogContentText>
                    <TextField
                      name="cost_user"
                      sx={{
                        "& legend": { display: "none" },
                        "& fieldset": { top: 0 },
                      }}
                      type="number"
                      value={values.cost_user}
                      onChange={handleChange}
                      fullWidth
                      placeholder={"Cost User"}
                      inputLabelProps={{ shrink: true }}
                    />
                  </Row>

                  <Row>
                    <DialogContentText>Cost Business Utility</DialogContentText>
                    <TextField
                      name="cost_business_utility"
                      sx={{
                        "& legend": { display: "none" },
                        "& fieldset": { top: 0 },
                      }}
                      type="number"
                      value={values.cost_business_utility}
                      onChange={handleChange}
                      fullWidth
                      placeholder={"Cost Business Utility"}
                      inputLabelProps={{ shrink: true }}
                    />
                  </Row>

                  <Row>
                    <DialogContentText>
                      Cost Business Authentication
                    </DialogContentText>
                    <TextField
                      name="cost_business_authentication"
                      sx={{
                        "& legend": { display: "none" },
                        "& fieldset": { top: 0 },
                      }}
                      type="number"
                      value={values.cost_business_authentication}
                      onChange={handleChange}
                      fullWidth
                      placeholder={"Cost Business Authentication"}
                      inputLabelProps={{ shrink: true }}
                    />
                  </Row>

                  <Row>
                    <DialogContentText>
                      Cost Business Marketing
                    </DialogContentText>
                    <TextField
                      name="cost_business_marketing"
                      sx={{
                        "& legend": { display: "none" },
                        "& fieldset": { top: 0 },
                      }}
                      type="number"
                      value={values.cost_business_marketing}
                      onChange={handleChange}
                      fullWidth
                      placeholder={"Cost Business Marketing"}
                      inputLabelProps={{ shrink: true }}
                    />
                  </Row>
                </DialogContent>
                <DialogActions>
                  <Button
                    onClick={() => {
                      handleClose();
                    }}
                  >
                    Cancel
                  </Button>
                  <Button type="submit">Edit</Button>
                </DialogActions>
              </Form>
            );
          }}
        </Formik>
      </Dialog>
    </>
  );
}
